import React from "react";
import "../Styles/Banners.scss";
import { ShieldCheck, Lock, Zap, Users } from "lucide-react";

const Banner = () => {
  return (
    <section className="hero">
      <div className="hero-inner">
        <div className="hero-content">
          {/* Top Tag Line with Dots */}
          <div className="partner-banner-tag-row">
            <span className="partner-banner-tag">PARTNER CENTER</span>
            <span className="partner-banner-dots">• •</span>
          </div>

          {/* Main Headline */}
          <h1 className="partner-hero-headline-serif">
            AI agents that <br />
            elevate every <br />
            <span className="partner-hero-orange-text">business interaction.</span>
          </h1>

          {/* Subdescription */}
          <p className="partner-hero-subdescription">
            Explore inFlow’s enterprise-grade AI agents designed to automate
            customer engagement, document workflows, and data insights across
            web, WhatsApp, voice, and internal systems. <br />
            Built for speed, accuracy, and seamless integration.
          </p>

          {/* Trust Metrics Bar (Transparent Inline Row with Vertical Dividers) */}
          <div className="partner-hero-metrics-grid">
            <div className="partner-metric-item">
              <ShieldCheck size={20} className="partner-metric-icon" />
              <div className="partner-metric-content">
                <span className="partner-metric-label">Enterprise ready</span>
                <span className="partner-metric-val">99.9% uptime</span>
              </div>
            </div>

            <div className="partner-metric-item">
              <Lock size={20} className="partner-metric-icon" />
              <div className="partner-metric-content">
                <span className="partner-metric-label">Secure & compliant</span>
                <span className="partner-metric-val">SOC 2 certified</span>
              </div>
            </div>

            <div className="partner-metric-item">
              <Zap size={20} className="partner-metric-icon" />
              <div className="partner-metric-content">
                <span className="partner-metric-label">Proven results</span>
                <span className="partner-metric-val">+32% engagement</span>
              </div>
            </div>

            <div className="partner-metric-item">
              <Users size={20} className="partner-metric-icon" />
              <div className="partner-metric-content">
                <span className="partner-metric-label">Active partners</span>
                <span className="partner-metric-val">1,250+</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
